import {Material, Matrix4, Mesh, MeshBasicMaterial, PlaneGeometry} from 'three'

const gridLimit = 100
const gridDistance = 10 // pixels
const gridCountBuffer = 10
const defaultBlack = 0x333333

function createMesh(gridSize: number, gridCount: number, material: Material) {
  const plane = new PlaneGeometry(gridSize, gridSize, gridCount, gridCount)
  const moveDown = new Matrix4().makeTranslation(0, 0, -1e-3)

  plane.applyMatrix4(moveDown)

  return new Mesh(plane, material)
}

export function createGridMesh(size = 1, material?: Material) {
  const planeSize = 1.1 * size
  const baseGridCount = Math.ceil(planeSize / gridDistance) + gridCountBuffer
  const numberOfGrids = Math.min(baseGridCount, gridLimit)
  const gridSize = gridDistance * numberOfGrids
  const meshMaterial = material ?? new MeshBasicMaterial({color: defaultBlack, wireframe: true})

  return createMesh(gridSize, numberOfGrids, meshMaterial)
}
